






























































import {Component, Vue, Prop, Model, Watch} from 'vue-property-decorator';
import {FilterItem} from './interfaces';

@Component({})
export default class SelectionListFilterMenu extends Vue {
  key = 0;

  // Тултип кнопки фильтра
  @Prop({required: true, type: String, default: ''})
  tooltip!: string;

  // Заголовок фильтра
  @Prop({required: true, type: String, default: ''})
  caption!: string;

  // Иконка кнопки фильтра
  @Prop({required: true, type: String})
  icon!: string;

  // Список элементов фильтра
  @Prop({required: true, type: Array})
  items!: FilterItem[];

  // Статус применения фильтра (нужен для отрисовки кнопки)
  @Prop({required: true})
  applyStatus!: boolean;

  // Показатель того, что кнопка отключена
  @Prop({type: Boolean, default: false})
  disabled!: string;

  @Prop({default: () => ({})})
  activators!: {};

  //Показатель наличия выбранных элементов фильтра
  get isSelected() {
    return this.applyStatus || this.changeSelectedItemKeys.some(x => x);
  }

  // Модель для меню (открыто\закрыто)
  menu = false;

  // Модель выбранных ключей элементов фильтра
  @Model('change') selectedItemKeys!: string[];
  get changeSelectedItemKeys() {
    return this.selectedItemKeys;
  }

  set changeSelectedItemKeys(newSelectedItemKeys: string[]) {
    this.$emit('change', newSelectedItemKeys);
  }

  @Watch('menu')
  onMenu(value: boolean) {
    if (!value) this.key++;
  }

  // Действия на клик
  click(e: any) {
    this.menu = false;
    this.$emit('click', e);
  }

  created() {
    this.items.sort((x: any, y: any) => y.value.localeCompare(x.value));
  }
}
